import draggable from 'vuedraggable';

export default {
  props: ['payload'],
  components: {
    draggable,
  },
  methods: {
    goBack() {
      window.history.back();
    },
    addPartToDocument(part) {
      this.payload.body.push(this.cloneNewPart(part));
    },
    addModuleToDocument(module) {
      this.payload.body.push(this.cloneNewModule(module));
      this.flattenModules();
    },
    isCoverThemeSelected(theme) {
      return this.payload.cover.backgroundColor === theme.backgroundColor && this.payload.cover.color === theme.color;
    },
    changeCoverTheme(theme) {
      this.$set(this.payload.cover, 'backgroundColor', theme.backgroundColor);
      this.$set(this.payload.cover, 'color', theme.color);
      this.$set(this.payload.cover, 'themeName', theme.name);
    },
    updateCoverBackgroundImage(upload) {
      this.payload.cover.backgroundImage = upload.url;
    },
    cloneNewPart(part) {
      let partClone = _.clone(part);
      partClone.id = Math.floor(Math.random() * 100000000);
      partClone.justCreated = true;
      return partClone;
    },
    cloneNewModule(module) {
      let moduleClone = _.map(_.clone(module.body), part => {
        part.id = Math.floor(Math.random() * 100000000);
        return part;
      });
      return moduleClone;
    },
    flattenModules() {
      this.$emit('update', _.flatten(this.payload.body));
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/document-sidebar.js